import { FormPanel, type FormPanelProps } from '@/components/common/FormPanel';

interface FormDetailPaneProps extends Omit<FormPanelProps, 'onCancel'> {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function FormDetailPane({ open, onOpenChange, ...panelProps }: FormDetailPaneProps) {
  if (!open) {
    return null;
  }

  return <FormPanel {...panelProps} onCancel={() => onOpenChange(false)} />;
}
